import { createTheme } from '@mui/material/styles';

const situationRoomDefaultTheme = createTheme({
  palette: {
    primary: {
      main: '#005F94',
    },
    secondary: {
      main: '#006D87',
    },
    error: {
      main: '#D15B5B',
    },
    warning: {
      main: '#D19C5B',
    },
    info: {
      main: '#5B9CD1',
    },
    success: {
      main: '#5BB8A7',
    },
    background: {
      default: '#F6F8FA',
      paper: '#ffffff',
    },
    text: {
      primary: '#1A364D',
      secondary: '#2C4B63',
      disabled: '#8FA0AD',
    },
  },
  typography: {
    fontFamily: 'Open Sans, -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica, Arial, sans-serif',
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: '#F6F8FA',
        },
      },
    },
  },
});

export default situationRoomDefaultTheme; 